const Headline = ({ label }) => {
    return (
        <div className="text-2xl font-semibold leading-7 text-gray-900 mt-3">
            {label}
        </div>
    )
}

export default Headline